<nz-date-picker
  [nzDisabled]="disable"
  [nzShowTime]="timePickerConfig"
  [nzFormat]="dateTimeFormat"
  [nzShowToday]="shouldShowNowButton"
  [ngModel]="currentValue"
  [nzPlaceHolder]="placeholder"
  nzDropdownClassName="date-time-picker-dropdown {{dropdownClassName}}"
  [ngClass]="{
    'show-prefix-calendar': shouldShowPrefixCalendarIcon,
    'hide-prefix-calendar': !shouldShowDefaultSuffixCalendarIcon,
    'active-datetime-picker': isDatetimePickerOpened
  }"
  (nzOnOpenChange)="toggleTimepickerActiveClass($event)"
  (ngModelChange)="updateCurrentValue($event)"
  (nzOnOk)="onOk($event)"
  i18n-nzPlaceHolder
>
</nz-date-picker>
